import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { FunctionService, ThemeService } from 'vhobjects-service';

@Component({
  selector: 'atw-radio-payment-method-config',
  templateUrl: './radio-payment-method-config.component.html',
  styleUrls: ['./radio-payment-method-config.component.scss']
})
export class AtwRadioPaymentMethodConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() blocks_of_page: any; // là dữ liệu blocks_of_page từ database
  @Input() type: any = 'page';

  currentViewAll: any = {}; // biến xác định mở rộng tất cả hay theo thuộc tính
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  valueRange: number = 0; // biến này tính giá trị của (input range / 100) để tính độ trong suốt
  valueParameter: number = 0; // biến này tính giá trị của (input range) để hiện thị giá trị ra màn hình
  style_color: string = '' // biến này lấy giá trị của màu rgb và alpha;

  backgroundColor: any = [];
  styles_field = [
    {
      title: 'dieu_chinh_noi_dung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien',
      index: 2,
    },
    {
      title: 'hieu_ung',
      index: 3,
    },
    {
      title: 'nang_cao',
      index: 4,
    },
    {
      title: 'nen_bieu_tuong',
      index: 5,
    },
  ];
  effect_hover = [];
  effect_hover_data: any = {}
  width = 0;
  height = 0;
  constructor(
    private vhEventMediator: VhEventMediator,
    public vhQueryAutoWeb: VhQueryAutoWeb,
    public themeService: ThemeService,
    public functionService: FunctionService
  ) { }

  ngOnInit() {
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class[this.objectChoosing.resize_field]['width'] = event.width + 'px';
    if (event.height) this.class[this.objectChoosing.resize_field]['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

   /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: false,
    menu2: true,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
  };
  openMapSub: { [name: string]: boolean } = { menu1: true, menu2: false };
  openHandler(value: string, isSub = false): void {
    const targetMap = isSub ? this.openMapSub : this.openMap;
    Object.keys(targetMap).forEach(key => {
      if (key !== value) targetMap[key] = false;
    });
  }

  /**
   *Hàm update class vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => { });
  }

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        // console.log('updateObject', bool);
      })
  }

    /**
   *Hàm update class vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        staticdata: this.staticdata,
      })
      .then((bool: any) => { });
  }

  /** Hàm thực hiện việc thay đổi vị trí của các collapse trong danh sách
   *
   */
  cdkDropListDropped(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.objectChoosing.staticdata.payment_methods, event.previousIndex, event.currentIndex);
  }

}
